export default {
  'yup_additions.status_check_integration_validation_schema.status_check_url_already_configured.error':
    'Health Check URL is already configured for the selected Observability Tool'
}
